module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921082651_T.5f5f87d5.jpg";